module.exports = __webpack_public_path__ + "img/t3-events.2122a0f3.png";